// MARK://dhk8/pos/features/pos/PosOverlays
// Single mount point for the global POS overlays: terminal lock screen + keyboard
// shortcuts (and the shortcuts cheat-sheet) + the manager-PIN gate prompt. Mounted once
// in `components/PosLayout` (right after the content area) so it covers every shelled
// route. The hooks attach to `window`, so they work app-wide regardless of which page
// is rendered.

import { useLockscreen } from '../../hooks/use-lockscreen.js'
import { useShortcuts } from '../../hooks/use-shortcuts.js'
import LockOverlay from '../shell/LockOverlay.js'
import ShortcutsDialog from '../shell/ShortcutsDialog.js'
import PinPromptSheet from '../security/PinPromptSheet.js'

export default function PosOverlays() {
  useLockscreen()
  const { shortcutsOpen, closeShortcuts } = useShortcuts()
  return (
    <>
      <LockOverlay />
      <ShortcutsDialog open={shortcutsOpen} onClose={closeShortcuts} />
      <PinPromptSheet />
    </>
  )
}
